import cx from 'classnames';
import { FC } from 'react';
import styles from '../alp.module.scss';
import { DealerLogoProps } from '../types';
import { CATCORP_LOGO_ALT_TEXT } from '../../header/constants';

export const DealerLogo: FC<DealerLogoProps> = ({ image, alt, className }) => (
  <img
    alt={alt ?? CATCORP_LOGO_ALT_TEXT}
    src={image}
    className={cx(styles['dealer-logo__height'], className)}
  />
);
